module.exports = __webpack_public_path__ + "static/img/4_IMG_20151228_164030.1504bf97.jpg";